import selectClients from './selectClients'

export { selectClients }

/* eslint import/prefer-default-export: "off" */
